import { Card, Skeleton, useSpinner } from '@chikara/ui';
import { t } from '@/i18n';
import type { LinkedAccount } from '../../types/credits.types';
import styles from './LinkedAccountSection.module.css';

export interface LinkedAccountSectionProps {
  data: LinkedAccount;
  supportEmail?: string;
}

export function LinkedAccountSection({
  data,
  supportEmail = 'ayuda@delt.ai',
}: LinkedAccountSectionProps) {
  const { isSpinnerLoading } = useSpinner();
  return (
    <section className={styles.section} aria-labelledby="linked-account-title">
      <h2 id="linked-account-title" className={styles.sectionTitle}>
        {t('credits.linkedAccountTitle')}
      </h2>
      {isSpinnerLoading ? (
        <Card className={styles.accountCard}>
          <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', padding: '1rem' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <Skeleton width="100px" height="14px" />
              <Skeleton width="160px" height="24px" />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <Skeleton width="100px" height="14px" />
              <Skeleton width="180px" height="24px" />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <Skeleton width="100px" height="14px" />
              <Skeleton width="140px" height="24px" />
            </div>
          </div>
        </Card>
      ) : (
        <Card className={styles.accountCard}>
          <Card.Stats
            label={t('credits.accountLabel')}
            value={data.accountName}
            className={styles.statItem}
          />
          <Card.Stats
            label={t('credits.clabeLabel')}
            value={data.clabe}
            className={styles.statItem}
          />
          <Card.Stats
            label={t('credits.bankLabel')}
            value={data.bankName}
            className={styles.statItem}
          />
        </Card>
      )}
      <p className={styles.helpText}>
        {t('credits.linkedAccountHelp')}{' '}
        <a
          href={`mailto:${supportEmail}`}
          className={styles.supportLink}
          rel="noopener noreferrer"
        >
          {supportEmail}
        </a>
      </p>
    </section>
  );
}

LinkedAccountSection.displayName = 'LinkedAccountSection';
